// extracted by mini-css-extract-plugin
export default {"box":"UnavailableExperience_box__pBUde","icon":"UnavailableExperience_icon__Df3e4","title":"UnavailableExperience_title__QHdiT","text":"UnavailableExperience_text__WN6CC"};